export default __webpack_public_path__ + "static/lavender-668bd7ecea599e0be8fcdd317d2f2930.svg";